import script from "./icon-shield-tick.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-shield-tick.vue?vue&type=script&lang=ts&setup=true"

import "./icon-shield-tick.vue?vue&type=style&index=0&id=04377832&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04377832"]])

export default __exports__